import { render, staticRenderFns } from "./ParsingProducts.vue?vue&type=template&id=0fa96a72&scoped=true"
import script from "./ParsingProducts.vue?vue&type=script&lang=ts"
export * from "./ParsingProducts.vue?vue&type=script&lang=ts"
import style0 from "./ParsingProducts.vue?vue&type=style&index=0&id=0fa96a72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa96a72",
  null
  
)

export default component.exports